<template>
  <organism-ticket-reply-template-data-management
    :fields="ticketReplyTemplateTableHeader"
    :items="ticketReplyTemplateTableData"
    @onSendRequestToCreateReplyTemplate="onSendRequestToCreateReplyTemplate"
    @onSendRequestToUpdateReplyTemplate="onSendRequestToUpdateReplyTemplate"
  ></organism-ticket-reply-template-data-management>
</template>

<script>
import OrganismTicketReplyTemplateDataManagement from "@/components/organisms/globalSetting/dataManagement/ticket/OrganismTicketReplyTemplateDataManagement.vue"
import mixins from "@/mixins"

import {
  replyTemplates,
  updateReplyTemplate,
  createNewReplyTemplate,
} from "@/api/api-module1"

export default {
  name: "TicketReplyTemplateDataManagement",

  mixins: [mixins],

  components: {
    OrganismTicketReplyTemplateDataManagement,
  },

  data() {
    return {
      ticketReplyTemplateTableHeader: [
        {
          key: "index",
          label: "#",
          thClass: "w-50px",
          tdClass: "w-50px",
        },
        {
          key: "replyTemplateName",
          label: "REPLY TEMPLATE NAME",
          thClass: "w-220px",
          tdClass: "w-220px",
        },
        {
          key: "replyTemplateMessage",
          label: "REPLY TEMPLATE MESSAGE",
          thClass: "w-220px",
          tdClass: "w-220px",
        },
      ],
      ticketReplyTemplateTableData: [],
    }
  },

  mounted() {
    this.fetchDataFromApi()
  },

  methods: {
    async fetchDataFromApi() {
      this.showLoading(true)
      await replyTemplates()
        .then((response) => {
          this.ticketReplyTemplateTableData = response.map((reply, index) => {
            return {
              index: index + 1,
              replyTemplateId: reply.replyTemplateId,
              replyTemplateName: reply.replyTemplateName,
              replyTemplateMessage: reply.replyTemplateMessage,
            }
          })
        })
        .finally(() => this.showLoading(false))
    },

    async onSendRequestToCreateReplyTemplate(newReplyTemplate) {
      this.showLoading(true)
      await createNewReplyTemplate(newReplyTemplate)
        .then(async (response) => {
          if (response) {
            this.toastSuccess("Created Reply Template Successfully")
            await this.fetchDataFromApi()
          }
        })
        .catch(() => {
          this.toastError("Create Reply Template Failed")
        })
        .finally(() => this.showLoading(false))
    },

    async onSendRequestToUpdateReplyTemplate(editedReplyTemplate) {
      const request = {
        replyTemplateName: editedReplyTemplate.replyTemplateName,
        replyTemplateMessage: editedReplyTemplate.replyTemplateMessage,
      }
      this.showLoading(true)
      await updateReplyTemplate(editedReplyTemplate.replyTemplateId, request)
        .then(async (response) => {
          if (response) {
            this.toastSuccess("Updated Reply Template Successfully")
            await this.fetchDataFromApi()
          }
        })
        .catch(() => {
          this.toastError("Update Reply Template Failed")
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
